module.exports = __webpack_public_path__ + "fonts/Lora-Regular--12c052959e60357f292b2bed94162d01.12c052959e60357f292b2bed94162d01.woff";